import * as Sentry from '@sentry/react';
import type { UseMutationResult } from '@tanstack/react-query';
import { useMutation } from '@tanstack/react-query';

import { downloadAllDocumentsAsZip } from '../../../../../shared/api/magellan/documents';
import { displayErrorNotification } from '../../../../../shared/components/notifications/errorNotification';
import { downloadFile } from '../../../../../shared/utils/download';

const MAX_FILE_NAME_LENGTH = 100;

export const useDownloadAllDocumentsAsZip = ({
  zipNameSegments,
}: {
  zipNameSegments: string[];
}): UseMutationResult<Blob, Error, number> => {
  return useMutation({
    mutationFn: downloadAllDocumentsAsZip,
    onSuccess: response => {
      handleDownload({ response, zipNameSegments });
    },
    onError: error => {
      Sentry.captureException(error);
      displayErrorNotification(
        'Erreur',
        "Nous n'avons pas réussi à télécharger les documents",
      );

      throw Error('Error while downloading documents');
    },
  });
};

// Creates an object URL for the Blob data
const handleDownload = ({
  response,
  zipNameSegments,
}: {
  response: Blob;
  zipNameSegments: string[];
}) => {
  if (response) {
    const url = window.URL.createObjectURL(response);
    const fileName = createFileName(zipNameSegments);

    downloadFile(url, fileName);

    window.URL.revokeObjectURL(url);
  }
};

const createFileName = (fileNameSegments: string[]) => {
  if (fileNameSegments.find(segment => !segment)) {
    throw new Error('Cannot create file name with undefined segments');
  }

  const fileName = fileNameSegments.join('-');
  return `${fileName.substring(0, MAX_FILE_NAME_LENGTH)}.zip`;
};
